import { useState } from 'react';

import SocialActivityAction from 'components/SocialActivityAction';
import PostHeader from 'components/PostHeader';
import PostDescription from 'components/PostDescription';
import LinkpostContent from 'components/LinkpostContent';
import CollaboratorsSlider from 'containers/CollaboratorsSlider';
import { likePost, unlikePost } from 'services/likePost';
import SocialActivity from 'components/SocialActivity';
import { useRouter } from 'next/router';
import { IProfileLinkPost } from './IProfileLinkPost';

import {
  LinkPostWrapper,
  MediaWrapper,
  SocialActivityBlock,
} from './ProfileLinkPost.styles';

const ProfileLinkPost = ({
  profilePhoto,
  userId,
  creatorId,
  username,
  fullname,
  isVerified,
  isAmbassador,
  isDonor,
  isMe,
  followingStatus,
  postTime,
  isClickable,
  link,
  linkImage,
  linkTitle,
  linkHost,
  origin,
  users,
  groups,
  events,
  text,
  locationName,
  isLike,
  likes,
  variant,
  id,
  isEventLikes,
  originId,
  commentsCount,
  sharesCount,
  collaborators,
  data,
  onCommentClick,
  onPinPress
}: IProfileLinkPost) => {
  const [postLike, setPostLike] = useState<boolean>(isLike);
  const [likesCount, setLikesCount] = useState<number>(likes || 0);
  const [isProfileLinkUrlCopied, setIsProfileLinkUrlCopied] =
    useState<boolean>(false);
  const router = useRouter();
  const onLikePost = (id) => {
    setPostLike(!postLike);
    if (postLike) {
      unlikePost(id).then((res) => {});
      setLikesCount(likesCount - 1);
      return;
    }
    likePost(id).then((res) => {
      // console.log(res)
    });
    setLikesCount(likesCount + 1);
  };
  const onPostClick = () => {
    const { origin: URLOrigin } = window.location;
    let url = URLOrigin;

    router.push(`${url}/p/${id}`);
  };

  return (
    <LinkPostWrapper>
      <PostHeader
        profilePhoto={profilePhoto}
        userId={userId}
        username={username}
        fullname={fullname}
        creatorId={creatorId}
        isVerified={isVerified}
        isAmbassador={isAmbassador}
        isDonor={isDonor}
        isMe={isMe}
        followingStatus={followingStatus}
        postTime={postTime}
        type={3}
        id={id}
        origin={origin}
        originId={originId}
        data={data}
        onPinPress={onPinPress}
      />
      {(text ||
        groups?.length ||
        users?.length ||
        events?.length ||
        locationName) && (
        <PostDescription
          origin={origin}
          users={users}
          groups={groups}
          events={events}
          text={text}
          locationName={locationName}
          type={3}
        />
      )}

      <MediaWrapper isClickable={isClickable} onClick={onPostClick}>
        <LinkpostContent
          linkImage={linkImage}
          linkTitle={linkTitle}
          linkHost={linkHost}
          description={text}
        />
      </MediaWrapper>
      <SocialActivityBlock>
        <SocialActivity
          id={id}
          onCommentClick={(id) => onCommentClick(id)}
          onLikeClick={(id) => onLikePost(id)}
          commentsNumber={commentsCount}
          sharesNumber={sharesCount}
          likesNumber={likesCount}
          isLike={postLike}
          postType={3}
          type="post"
          isUrlCopied={isProfileLinkUrlCopied}
          setIsUrlCopied={setIsProfileLinkUrlCopied}
        />
      </SocialActivityBlock>
      {collaborators?.length > 0 && (
        <CollaboratorsSlider collaborators={collaborators} />
      )}
    </LinkPostWrapper>
  );
};

export default ProfileLinkPost;
